interface IconCheckProps {
    className?: string;
}

const IconCheck = (props: IconCheckProps) => {
    const { className } = props;

    return (
        <svg
            className={className}
            width="11"
            height="11"
            viewBox="0 0 16 16"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
        >
            <path d="M3 8.5l3.5 3.5L13 4.5" />
        </svg>
    );
};

export default IconCheck;
